import Axios from "axios";
import Vue from "vue";
import VueLocalStorage from "vue-localstorage";

Vue.use(VueLocalStorage);

let instance = null;

const BASE_URL = "https://www.googleapis.com/calendar/v3/calendars/";

const HTTP = Axios.create({
  baseURL: BASE_URL,
  headers: {
    "key": "AIzaSyDS__4VGH53LynhserriDx-eDCUCe6Ovgc"
  }
});

class Service {
  constructor(){
    if (!instance) instance = this;
    return instance;
  }

  listHolidays(){
    return HTTP.post(`es.pe%23holiday%40group.v.calendar.google.com/events`).then(res => res).catch(err => err)
  }
}

export const calendar = new Service();